import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "linkedin-step__content",
  "data-testid": "freelancer-signup-completion-linkedin-import-step"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "linkedin-step__content__divider"
}
const _hoisted_4 = {
  key: 1,
  class: "linkedin-step__content__use-desktop"
}
const _hoisted_5 = ["innerHTML"]

import {ref, onBeforeUnmount, onMounted} from 'vue';
    import {useTranslation} from '@malt/vue3-use';
    import ImportButton from './ImportButton.vue';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'LinkedinImportContent',
  props: {
        description: {
            type: String,
            required: true,
        },
        howToProceed: {
            type: String,
            required: true,
        },
    },
  emits: ["selected-import-from-linkedin", "selected-add-manually"],
  setup(__props, { emit: __emit }) {

    const {msg} = useTranslation();

    

    const mobileSM = ref<boolean>(false);

    const importOptionsData = [
        {
            icon: 'linkedin',
            title: msg('profile.creation.completion.wizard.v2.linkedin.import.title'),
            description: msg('profile.creation.completion.wizard.v2.linkedin.import.description'),
            duration: msg('profile.creation.completion.wizard.v2.linkedin.import.duration', 5),
            isMainTag: true,
            event: 'selected-import-from-linkedin',
            type: 'linkedin-import',
            dataTestid: 'freelancer-signup-completion-linkedin-import-step-cta-linkedin',
        },
        {
            icon: 'freelancer-placeholder',
            title: msg('profile.creation.completion.wizard.v2.linkedin.manual.title'),
            duration: msg('profile.creation.completion.wizard.v2.linkedin.manual.duration', 15),
            event: 'selected-add-manually',
            type: 'manual',
            dataTestid: 'freelancer-signup-completion-linkedin-import-step-cta-manual',
        },
    ];

    const emit = __emit;

    function isMobileSM(): boolean {
        return window.matchMedia('(max-width: 991px)').matches;
    }

    function onResize(): void {
        mobileSM.value = isMobileSM();
    }

    onMounted(async () => {
        window.addEventListener('resize', onResize);
        mobileSM.value = isMobileSM();
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', onResize);
    });

return (_ctx: any,_cache: any) => {
  const _component_VJoyIcon = _resolveComponent("VJoyIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: "linkedin-step__content__description",
      innerHTML: __props.description
    }, null, 8, _hoisted_2),
    _createElementVNode("h3", null, _toDisplayString(__props.howToProceed), 1),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(importOptionsData, (option, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: `option-${index}`
      }, [
        (!(mobileSM.value && option.type === 'linkedin-import'))
          ? (_openBlock(), _createBlock(ImportButton, _mergeProps({
              key: 0,
              ref_for: true
            }, option, {
              "data-testid": option.dataTestid,
              onClick: ($event: any) => (emit(option.event))
            }), null, 16, ["data-testid", "onClick"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 64)),
    (mobileSM.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.linkedin.mobile.divider')), 1))
      : _createCommentVNode("", true),
    (mobileSM.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_VJoyIcon, {
            name: "linkedin",
            size: "small",
            class: "linkedin-cta__icon"
          }),
          _createElementVNode("span", {
            innerHTML: _unref(msg)('profile.creation.completion.wizard.v2.linkedin.mobile.use.desktop')
          }, null, 8, _hoisted_5)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})